// @flow

import styled from 'styled-components';

export default styled.div`
  margin: 12rem 0 0 5rem;
  &.rtl {
    margin: 12rem 5rem 0 0;
    .contentWrapper {
      > .qrWrapper {
        float: right;
      }
      > .urlWrapper {
        float: left;
        margin: 0 0 0 2rem;
        > .description {
          > .bullet {
            margin: 0 0 0 1rem;
          }
        }
      }
    }
  }
  .version {
    position: fixed;
    bottom: .5rem;
    left: 0;
    right: 0;
    font-size: 1rem;
    color: #4f4f4f;
    text-align: center;
  }
  .contentWrapper {
    display: table;
    margin-top: 13rem;
    width: 100%;
    > .qrWrapper {
      float: left;
      width: 20rem;
      height: 20rem;
      margin: 0 2rem;
      background: rgba(255,255,255,.04);
      > img {
        display: table;
        margin: 0 auto;
        width: 100%;
      }
    }
    > .urlWrapper {
      float: right;
      width: calc(100% - 26rem);
      margin: 0 2rem 0 0;
      > .title {
        font-size: 3rem;
        color: #fff;
        margin: .2rem 0 2.2rem;
      }
      > .description {
        font-size: 1.6rem;
        color: #fff;
        line-height: 3rem;
        > .highligt {
          margin: 0;
          font-size: 1.8rem;
          font-family: Tahoma;
          color: #000;
          font-weight: bold;
          background-color: #ea1d5d;
          padding: .5rem 1rem;
          &.code {
            margin: 0 .5rem;
          }
        }
      }
    }
  }
`;
